<template>
  <v-card
    color="primary"
    dark
    flat
    :max-width="$attrs['max-width']"
    :class="$attrs['class']"
  >
    <v-card-title class="text-h5">
      {{ title }}
    </v-card-title>
    <v-card-text class="text-h4 font-weight-bold">
      {{ text }}
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    text: {
      type: [String, Number],
      default: null
    }
  }
}
</script>

<style scoped>
.text-h5 {
  word-wrap: break-word;
  word-break: break-word;
}
</style>
